import script from "./InvoiceServiceSection.vue?vue&type=script&setup=true&lang=js"
export * from "./InvoiceServiceSection.vue?vue&type=script&setup=true&lang=js"

import "./InvoiceServiceSection.vue?vue&type=style&index=0&id=637ef20e&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-637ef20e"]])

export default __exports__